import(/* webpackMode: "eager" */ "/codebuild/output/src1032606101/src/admin-command-center/src/app/page.tsx");
